import { ProjectsReducerState } from './types';

export const defaultState: ProjectsReducerState = [];
